import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats
} from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { startWith, tap } from 'rxjs';

@Component({
  standalone: false,
  selector: 'calendar-header',
  templateUrl: './calendar-header.component.html',
  styleUrl: './calendar-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarHeaderComponent {
  private readonly _calendar = inject(MatCalendar<void>, { skipSelf: false });
  private readonly _dateAdapter = inject(DateAdapter<void>);
  private readonly _dateFormats = inject<MatDateFormats>(MAT_DATE_FORMATS);
  private readonly _destroyRef = inject(DestroyRef);

  readonly periodLabel = signal('');

  constructor() {
    this._calendar.stateChanges
      .pipe(
        startWith(null),
        takeUntilDestroyed(this._destroyRef),
        tap(() => {
          this.periodLabel.set(
            this._dateAdapter
              .format(
                this._calendar.activeDate,
                this._dateFormats.display.monthYearLabel
              )
              .toLocaleUpperCase()
          );
        })
      )
      .subscribe();
  }

  periodClicked(): void {
    this._calendar.currentView =
      this._calendar.currentView === 'month' ? 'multi-year' : 'month';
  }

  previousClicked(): void {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
      this._calendar.activeDate,
      -1
    );
  }

  nextClicked(): void {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
      this._calendar.activeDate,
      1
    );
  }
}
